import React from "react";
import { Routes, Route } from "react-router-dom";
import { SessionContextProvider } from '@supabase/auth-helpers-react';
import { supabase } from '@/integrations/supabase/client';
import HomePage from "./pages/HomePage";
import Index from "./pages/Index";
import CareerArtifactsPage from "./pages/CareerArtifactsPage";
import BigSheetPage from "./pages/BigSheetPage";
import OpportunityAuditPage from "./pages/OpportunityAuditPage";
import PowerMovesPage from "./pages/PowerMovesPage";
import OKRsPage from "./pages/OKRsPage";
import CreateOKRPage from "./pages/CreateOKRPage";
import ScorePage from "./pages/ScorePage";
import DashboardPage from "./pages/DashboardPage";
import ProductManagementAssessment from "./pages/ProductManagementAssessment";
import RateWhispererPage from "./pages/RateWhispererPage";
import AuthPage from "./pages/AuthPage";
import SavedArtifactsPage from "./pages/SavedArtifactsPage";
import NotFoundPage from "./pages/NotFoundPage";
import ModernAppLayout from "./components/layout/ModernAppLayout";
import { usePostHogSurveys } from "./hooks/usePostHogSurveys";
import FeedbackTrigger from "./components/feedback/FeedbackTrigger";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { AnalyticsProvider } from "./components/analytics/AnalyticsProvider";

const App = () => {
  // Initialize PostHog surveys
  usePostHogSurveys();
  
  return (
    <ErrorBoundary>
      <SessionContextProvider supabaseClient={supabase}>
        <AnalyticsProvider>
          <div className="flex flex-col min-h-screen relative">
            <ModernAppLayout session={null}>
              <ErrorBoundary>
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/home" element={<HomePage />} />
                  <Route path="/artifacts" element={<CareerArtifactsPage />} />
                  <Route path="/artifacts/big-sheet" element={<BigSheetPage />} />
                  <Route path="/artifacts/power-moves" element={<PowerMovesPage />} />
                  <Route path="/artifacts/okrs" element={<OKRsPage />} />
                  <Route path="/artifacts/okrs/create" element={<CreateOKRPage />} />
                  <Route path="/artifacts/opportunity-audit" element={<OpportunityAuditPage />} />
                  <Route path="/artifacts/saved" element={<SavedArtifactsPage />} />
                  {/* Legacy routes for backwards compatibility */}
                  <Route path="/big-sheet" element={<BigSheetPage />} />
                  <Route path="/opportunity-audit" element={<OpportunityAuditPage />} />
                  <Route path="/power-moves" element={<PowerMovesPage />} />
                  <Route path="/okrs" element={<OKRsPage />} />
                  <Route path="/okrs/create" element={<CreateOKRPage />} />
                  <Route path="/score" element={<ScorePage />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/assessment/product-management" element={<ProductManagementAssessment />} />
                  <Route path="/rate-whisperer" element={<RateWhispererPage />} />
                  <Route path="/workspace" element={<Index workspace={true} />} />
                  <Route path="/auth" element={<AuthPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </ErrorBoundary>
            </ModernAppLayout>
            
            {/* Floating feedback button */}
            <FeedbackTrigger variant="floating" />
          </div>
        </AnalyticsProvider>
      </SessionContextProvider>
    </ErrorBoundary>
  );
};

export default App;